/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    eventBus: {
      on: (eventName: string, callback: (...args: any[]) => void) => void;
      detach: (eventName: string, callback?: (...args: any[]) => void) => void;
      emit: (eventName: string, context: object | null, data: object) => void;
    };
  }
}
/**
 * This is the legacy eventbus.js to communicate with cotd-website
 */
export const legacyEventBus =
  typeof window != "undefined" ? window.eventBus : undefined;
